/**
 * Created by Angelika on 02.11.2017.
 */
import React from 'react';
import {Route, IndexRoute} from 'react-router';
import Layout from './containers/Layout';
import ChannelFrame from './containers/ChannelFrame';
import PlayerFrame from './containers/PlayerFrame';
import UserDataFrame from './containers/UserDataFrame';
import NotFound from './components/NotFound';

const routes = (
    <Route exact path="/" component={Layout}>
        <IndexRoute component={ChannelFrame} />
        <Route path="/channels" component={ChannelFrame} />
        <Route path="/channels/:channelID" component={PlayerFrame} />
        <Route path="/user" component={UserDataFrame} />
        <Route path="*" component={NotFound} />
    </Route>
);

export default routes;


// WEBPACK FOOTER //
// ./src/routes.js